import script from "./SolicitudesView.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitudesView.vue?vue&type=script&setup=true&lang=js"

import "./SolicitudesView.vue?vue&type=style&index=0&id=fc8b9f44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc8b9f44"]])

export default __exports__